import { gql } from '@apollo/client';

import { COMMENT_FIELDS, TASK_LIGHT_FRAGMENT } from './fragments';

export const GET_SUPPORT_TASKS_QUERY = gql`
  query Task_FindByFolder(
    $limit: Int!
    $after: Int
    $folder: String!
    $priorities: [TaskPriorities!]
    $assignees: [String!]
    $unassigned: Boolean
  ) {
    Task_FindByFolder(
      limit: $limit
      after: $after
      folder: $folder
      priorities: $priorities
      assignees: $assignees
      unassigned: $unassigned
    ) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const GET_SUPPORT_TASK_QUERY = gql`
  query Task_FindOne($id: String!) {
    Task_FindOne(id: $id) {
      ...TaskLight
      descriptionJson
      dueDate
      ticket
      ticketReference
      attachments {
        key
        originalFilename
        size
        type
        url
      }
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const GET_SUPPORT_TASK_COMMENTS_QUERY = gql`
  query TaskComment_FindAllByTaskId($taskId: String!) {
    TaskComment_FindAllByTaskId(taskId: $taskId) {
      ...TaskCommentFields
    }
  }
  ${COMMENT_FIELDS}
`;

export const GET_SUPPORT_TASK_ACTIVITY_QUERY = gql`
  query Task_Activity($taskId: String!) {
    Task_Activity(taskId: $taskId) {
      id
      type
      triggeredByUser
      createdAt
      assignee
      folder
      priority
      dueDate
      tags
      fromAssignee
      fromFolder
      fromPriority
      fromDueDate
      changedFields
    }
  }
`;

export const GET_SUPPORT_TASK_FOLDER_COUNTS_QUERY = gql`
  query TaskFolder_CountAll {
    TaskFolder_CountAll {
      id
      count
      unread
      name
      systemName
    }
  }
`;

export const GET_SUPPORT_TASK_FOLDERS_QUERY = gql`
  query TaskFolder_List {
    TaskFolder_List {
      id
      name
      icon
      color
      sortingIndex
      systemName
    }
  }
`;
